import Fuse from 'fuse.js';

import type {Channel} from '../../../modules/channel/types';

export const findChannels = (
  channels: Channel[],
  query: string,
  isDM = false,
) => {
  const fuse = new Fuse(channels, {
    keys: [
      'title',
      !isDM ? 'resource.program.title' : null,
      !isDM ? 'resource.client.name' : null,
      'description',
      'last_post.body',
      'last_post.user.name',
      'members.name',
    ].filter(Boolean),
    shouldSort: false,
    threshold: 0.3,
  });

  return fuse.search(query).map(item => item.item);
};
